import { useMsal } from '@azure/msal-react';
import { useMemo } from 'react';
import { ApiClient } from './api-client.js';

const PLACEHOLDER_BASE_URL = 'http://localhost:3000';
const PLACEHOLDER_API_AUDIENCE = 'api://wf-coe-engine-dev';

/**
 * Returns an {@link ApiClient} bound to the current MSAL account, or
 * `undefined` when the user isn't signed in (so query hooks can disable
 * themselves until login completes).
 *
 * Memoized on the MSAL instance + account so TanStack Query can rely on
 * `enabled: !!api` without spawning a fresh client per render.
 */
export function useApiClient(): ApiClient | undefined {
  const { instance, accounts } = useMsal();
  const account = accounts[0];

  return useMemo(() => {
    if (!account) return undefined;
    return new ApiClient({
      baseUrl: import.meta.env.VITE_API_BASE_URL ?? PLACEHOLDER_BASE_URL,
      apiAudience: import.meta.env.VITE_MSAL_API_AUDIENCE ?? PLACEHOLDER_API_AUDIENCE,
      msal: instance,
      account,
    });
  }, [instance, account]);
}
